<template>
  <main class="auth-page">
    <div class="auth-page__decoration auth-page__decoration--top" aria-hidden="true"></div>
    <div class="auth-page__decoration auth-page__decoration--bottom" aria-hidden="true"></div>

    <section class="auth-shell" aria-label="Teacher portal sign in">
      <header class="auth-shell__header">
        <a class="auth-brand" href="https://taleem.app" aria-label="Taleem home">
          <span class="auth-brand__mark" aria-hidden="true">t</span>
          <span class="auth-brand__word">taleem<span>.app</span></span>
        </a>
        <span class="auth-badge">Teacher portal</span>
      </header>

      <div class="auth-shell__content">
        <router-view />
      </div>

      <footer class="auth-shell__footer">
        <v-icon size="15" color="#718096">mdi-lock-outline</v-icon>
        <span>Your sign-in is secure</span>
      </footer>
    </section>
  </main>
</template>

<script>
import authService from "./store.js";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";

export default {
  name: "authentication",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("auth", authService);

    const loginToken = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}token`
    );
    if (loginToken && this.$route.path !== "/resetPassword") this.$router.push({ path: "/" });
  },
};
</script>
